import { createFileRoute } from '@tanstack/react-router'

import PagePocRecipeHistory from '@/pages/PagePocRecipeHistory'

export const Route = createFileRoute('/poc/recipe-generator/history')({
  component: PagePocRecipeHistory
})
